import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { AppConfigServices } from '../../services/AppConfigServices';
import * as BullCache from "../../util/BullCache";
import '../custom.css';

function AppConfig() {

    const[appConfig,setAppConfig]=useState([]);
    const [editedValues, setEditedValues] = useState({});  

    var adminId = BullCache.getFromCache("user");

  useEffect(() => {     
      fetchData();     
    }, []); 

  const fetchData = () => {
    AppConfigServices.getAppConfig({adminId: adminId.adminId})
      .then((resp) => {
        if (resp.code === 1 && resp.data.appConfigList.length > 0) {
            setAppConfig(resp.data.appConfigList);
        } else {
            setAppConfig([]); 
        }
      })
      .catch((error) => {
      });
  };

  const handleValueChange = (key, newValue) => {
    setEditedValues((prev) => ({
      ...prev,
      [key]: newValue
    }));
  };

  const handleUpdate = (key, originalValue) => {
    const updatedValue = editedValues[key] || originalValue;
    
    AppConfigServices.updateAppConfig({      
        adminId: adminId.adminId,
        configKey: key,
        configValue: updatedValue,
  })
  .then((resp) => {
    if (resp.code === 1) {
      Swal.fire({
        title: "Success!",
        text: "Configuration updated successfully.",
        icon: "success",
        confirmButtonText: 'Okay',
      }).then(() => {
        window.location.reload(); 
      });
    } else {
      Swal.fire({
        title: "Error",
        text: resp.messages || "Something went wrong!",
        icon: "error",
      });
    }
  })
  .catch((error) => {
    console.error('Error updating config:', error);
    Swal.fire({
      title: "Error",
      text: "An error occurred while updating the data. Please try again.",
      icon: "error",
    });
  });

};

const handleScriptRefresh = () => {
        Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes ',
            cancelButtonText: 'No',
            cancelButtonColor: "#d33",
        }).then((result) => {
            if (result.isConfirmed) {
                AppConfigServices.refreshScript({ 'loginId': adminId.adminId }).then(res => {
                    if (res.code === 1) {
                        Swal.fire({
                            icon: 'success',
                            text: 'Scripts Refreshed!'
                        })
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: res.messages || "Found an issue while refreshing scripts!"
                        });
                    }
                });
            }
          });
    }

    return (
      
    <Card className='mt-1'>
        <Card.Body>
          <Row>
            <Col xl={2} sm={2} xs={3}>
                <Button variant="secondary" size="sm" className="" onClick={handleScriptRefresh}>
                                    Refresh Script
                                </Button>
            </Col>
          </Row>
          <hr></hr>
    <Row className=''>
    <Col sm={2} xs={4}>
        <b className=''>Key</b>
    </Col>

    <Col sm={4} xs={8}>
    <b className=''>Value</b>
        
    </Col>
</Row>
{appConfig.length > 0 ? (
 appConfig.map((config, index) => (
 <Row key={index} className="mt-2">
    <Col sm={2} xs={4}>
    <b className="fss-06">{config.configKey}</b> 
    </Col>

    <Col sm={8} xs={8}>
        <Form.Control type='text' className='bg-light text-black form-control form-control-sm'  as="textarea" 
         defaultValue={config.configValue} 
         onChange={(e) => handleValueChange(config.configKey, e.target.value)}  />
    </Col>
    <Col className='mt-1 text-center me-4 '>
     <Button variant='success' className='fss-02'
     onClick={() => handleUpdate(config.configKey, config.configValue)}>Update</Button>
    </Col>
</Row>
 ))
) : (
  <Row className="mt-2">
    <Col sm={12}>
      <p>No configuration data available.</p>
    </Col>
  </Row>
)}
</Card.Body>
</Card>
    );
}
export default AppConfig;